import axiosOverlay from '../../js/axiosOverlay'

const state = {
    natures: null,
    selectedNature: null,
    iCanWrite: [],
    iCantRead: []
};

const getters = {
    natures: state => state.natures,
    selectedNature: state => state.selectedNature,
    iCanWrite: state => state.iCanWrite,
    iCantRead: state => state.iCantRead,
    getNatureById: (state) => (natureID) => {
        return JSON.parse(state.natures)?.find(nature => nature.id === natureID) ?? null
    },
    getMyNature: (state, getters, rootState, rootGetters) => {
        let myNature = []
        let allNature = JSON.parse(state.natures)
        if (allNature) {
            allNature.forEach(function(nature) {
                let flag = true
                if (nature.roleFiltresWrite != null) {
                    rootGetters['user/getRoles'].forEach(function (role) {
                        if (nature.roleFiltresWrite.includes(role)) {
                            flag = false
                        }
                    });
                }
                if (flag){
                    myNature.push(nature)
                }
            });
        }
        return myNature
    }
};

const mutations = {
    SET_NATURES(state, natures) {
        state.natures = natures;
    },
    SET_SELECTED_NATURE(state, natureID) {
        state.selectedNature = natureID;
    },
    SET_I_CAN_WRITE(state, list) {
        state.iCanWrite = list;
    },
    SET_I_CANT_READ(state, list) {
        state.iCantRead = list;
    }
};

const actions = {
    async loadNaturesFromAPI({ commit, state, rootGetters }) {
        if (state.natures === null) {
            let config = {
                method: 'get',
                url: process.env.VUE_APP_API_URL + "/sollicitation/natures",
                headers: { }
            };

            try {
                const response = await axiosOverlay(config);
                let result = JSON.stringify(response.data);
                commit('SET_NATURES', result);

                let iCanWrite = [];
                let iCantRead = [];
                let allNature = JSON.parse(result);
                
                allNature.forEach(function (nature) {
                    // Remplissage de ce que je peux écrire
                    let flagWrite = true;
                    if (nature.roleFiltresWrite != null) {
                        rootGetters['user/getRoles'].forEach(function (role) {
                            if (nature.roleFiltresWrite.includes(role)){
                                flagWrite = false;
                            }
                        });
                    }
                    if (flagWrite) {
                        iCanWrite.push(nature);
                    }

                    // Remplissage de ce que je peux lire
                    let flagRead = true;
                    if (nature.roleFiltresRead != null) {
                        rootGetters['user/getRoles'].forEach(function (role) {
                            if (nature.roleFiltresRead.includes(role)){
                                flagRead = false;
                            }
                        });
                    }
                    if (!flagRead) {
                        iCantRead.push(nature);
                    }
                });
                
                commit('SET_I_CAN_WRITE', iCanWrite);
                commit('SET_I_CANT_READ', iCantRead);
                
            } catch (error) {
                console.log(error);
            }
        }
    },
    
    setSelectedNature({ commit }, natureID) {
        commit('SET_SELECTED_NATURE', natureID);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
